'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareComputer = function HardwareComputer(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z' })
  );
};
HardwareComputer = (0, _pure2.default)(HardwareComputer);
HardwareComputer.displayName = 'HardwareComputer';
HardwareComputer.muiName = 'SvgIcon';

exports.default = HardwareComputer;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/hardware/computer.js
// module id = 1440
// module chunks = 0